/**
 * Cart shipping fee estimator.
 *
 * Loaded ONCE per page via a normal <script src> tag (see theme.liquid).
 * Uses event delegation on `document` so it keeps working no matter how
 * many times the cart drawer/section markup gets re-rendered via AJAX
 * (adding items, opening the drawer, section morphing, etc.) — this is
 * what fixes the "works after reload but not on first load" issue.
 */
(function () {
  if (window.__cartShippingCalcInit) return;
  window.__cartShippingCalcInit = true;

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function resetState(scope) {
    var loadingEl = scope.querySelector('#shipping-loading');
    var errorEl = scope.querySelector('#shipping-error');
    var resultEl = scope.querySelector('#shipping-result');
    var totalEl = scope.querySelector('#shipping-total');
    if (!loadingEl) return;
    loadingEl.classList.add('hidden');
    errorEl.classList.add('hidden');
    resultEl.classList.add('hidden');
    totalEl.classList.add('hidden');
    errorEl.textContent = '';
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('#shipping-governorate');
    if (!select) return;

    var scope = select.closest('.cart-shipping-calculator');
    if (!scope) return;

    var governorate = select.value;
    resetState(scope);
    if (!governorate) return;

    var loadingEl = scope.querySelector('#shipping-loading');
    var errorEl = scope.querySelector('#shipping-error');
    var resultEl = scope.querySelector('#shipping-result');
    var totalEl = scope.querySelector('#shipping-total');
    var feeEl = scope.querySelector('#shipping-fee-value');
    var totalValEl = scope.querySelector('#shipping-total-value');

    // Read the current cart total & money format fresh from the markup
    // each time, so it's always accurate even after the cart changes.
    var moneyFormat = scope.getAttribute('data-money-format') || '${{amount}}';
    var cartTotalCents = parseInt(scope.getAttribute('data-cart-total'), 10) || 0;

    loadingEl.classList.remove('hidden');
    select.disabled = true;

    fetch(
      '/cart/shipping_rates.json?shipping_address[country]=Egypt&shipping_address[province]='
        + encodeURIComponent(governorate)
        + '&shipping_address[zip]=00000'
    )
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.json();
      })
      .then(function (data) {
        var rates = data.shipping_rates;
        loadingEl.classList.add('hidden');

        if (rates && rates.length > 0) {
          var rate = rates[0];
          var feeCents = Math.round(parseFloat(rate.price) * 100);

          feeEl.textContent = formatMoney(feeCents, moneyFormat);
          totalValEl.textContent = formatMoney(cartTotalCents + feeCents, moneyFormat);

          resultEl.classList.remove('hidden');
          totalEl.classList.remove('hidden');
        } else {
          errorEl.textContent = 'Delivery is not available for this governorate.';
          errorEl.classList.remove('hidden');
        }
      })
      .catch(function () {
        loadingEl.classList.add('hidden');
        errorEl.textContent = 'Unable to calculate shipping. Please try again.';
        errorEl.classList.remove('hidden');
      })
      .finally(function () {
        select.disabled = false;
      });
  });
})();